module.exports = __webpack_public_path__ + "img/img_32389_0_246.bfc98898.png";